import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 relative overflow-hidden" data-id="element-107">
      <div className="max-w-md sm:max-w-lg mx-auto text-center relative z-10" data-id="element-108">
        {/* Attention pill */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-brand-surface border border-brand-red/40 px-4 py-1.5 rounded-full mb-5" data-id="element-109">
          <span className="w-2 h-2 rounded-full bg-brand-red animate-pulse" data-id="element-110" />
          <span className="sm:text-xs font-black tracking-wider text-brand-red uppercase text-[9px]" data-id="element-111">
            ACHTUNG: SKI-INSTRUKTOREN IN DER SCHWEIZ DIE JEDEN ABEND STUNDEN MIT
            VORBEREITUNG VERSCHWENDEN
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="sm:text-5xl font-black text-brand-navy mb-5 text-[20px]" data-id="element-112">
          Unterrichte eine komplette Saison wie eine{' '}
          <span className="text-brand-gold underline decoration-brand-gold/40 underline-offset-4" data-id="element-113">
            Elite-Akademie
          </span>{' '}
          — <span className="text-brand-red" data-id="element-114">ab morgen</span>.
        </motion.h1>

        {/* Subheadline card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-brand-surface border-l-4 border-brand-navy rounded-r-lg px-4 py-3 mb-6 text-left shadow-sm" data-id="element-115">
          <p className="text-sm sm:text-base text-brand-muted leading-snug" data-id="element-116">
            Das erste System mit{' '}
            <span className="text-brand-navy font-bold" data-id="element-117">
              biomechanischen Protokollen
            </span>
            , <span className="text-brand-navy font-bold" data-id="element-118">VIP-Field Cards</span>{' '}
            und{' '}
            <span className="text-brand-navy font-bold" data-id="element-119">
              Swiss Champions Methodik
            </span>
            .{' '}
            <span className="text-brand-text font-bold" data-id="element-120">
              Fertig. Sofort einsatzbereit.
            </span>
          </p>
        </motion.div>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15
      }} className="mb-6" data-id="element-121">
          <a href="#pricing" className="block cursor-pointer" data-id="element-122">
            <img src="https://cdn.magicpatterns.com/uploads/srY18Uh6GpYmfVpX2otuR3/swiss_champions_mockup.jpg" alt="Swiss Champions — Das Komplett-System" className="w-full h-auto object-contain drop-shadow-xl rounded-xl" data-id="element-123" />
          </a>
          <p className="text-xs text-brand-navy font-bold uppercase tracking-wider mt-3" data-id="element-124">
            Swiss Champions™ — Das Komplett-System
          </p>
        </motion.div>

        {/* Star rating */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex items-center justify-center gap-2 mb-3" data-id="element-125">
          <div className="flex" data-id="element-126">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-brand-gold fill-current drop-shadow-[0_0_6px_rgba(201,164,73,0.4)]" data-id="element-127" />)}
          </div>
          <span className="text-sm font-bold text-brand-navy" data-id="element-128">
            4.9/5 (+200 verifizierte Bewertungen)
          </span>
        </motion.div>

        {/* Scarcity pill */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.25
      }} className="inline-flex items-center gap-2 border border-brand-red/20 bg-brand-red/5 px-4 py-1.5 rounded-full mb-5" data-id="element-129">
          <span className="text-sm font-bold text-brand-red" data-id="element-130">
            🔥 38 Instruktoren haben dieses System heute gewählt
          </span>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-131">
          <CTAButton className="w-full" data-id="element-132">
            JA! ICH WILL MEIN SYSTEM JETZT
          </CTAButton>
        </motion.div>

        {/* Trust line */}
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-5 text-xs text-brand-muted font-medium" data-id="element-133">
          <span data-id="element-134">⚡ Sofortiger Zugang</span>
          <span className="text-brand-border" data-id="element-135">•</span>
          <span data-id="element-136">🛡️ 7-Tage-Garantie</span>
          <span className="text-brand-border" data-id="element-137">•</span>
          <span data-id="element-138">💳 Einmalzahlung</span>
        </div>

        {/* Country/Resource line */}
        <div className="mt-5 flex flex-col items-center justify-center gap-2" data-id="element-139">
          <div className="flex gap-2 text-xl" data-id="element-140">🇨🇭 🇩🇪 🇦🇹 🇫🇷 🇬🇧</div>
          <p className="text-xs text-brand-muted font-medium text-center" data-id="element-141">
            Die Nr. 1 digitale Infrastruktur für Elite-Ski-Instruktoren in den
            Schweizer Alpen.
          </p>
        </div>
      </div>
    </section>;
}